//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

export const WelcomeEmail = {
  filter: [
    {
      label: "Member ID",
      key: "Member ID",
    },
    {
      label: "First Name",
      key: "First Name",
    },
    {
      label: "Last Name",
      key: "Last Name",
    },
    {
      label: "Email",
      key: "Email",
    },
    {
      label: "Loyalty Status",
      key: "Loyalty Status",
    },
   
  ],

  columns: [
    {
      label: "Member ID",
      key: "Member ID",
    },
    {
      label: "First Name",
      key: "First Name",
    },
    {
      label: "Last Name",
      key: "Last Name",
    },
    {
      label: "Email",
      key: "Email",
    },
    {
      label: "Loyalty Status",
      key: "Loyalty Status",
    },
   
  ],
};
export const ConsentedAndNonConsentedWeekly = {
  filter: [
    {
      label: "Is Consented?",
      key: "Is_Consented?",
    },
   
    {
      label: "JDE",
      key: "JDE",
    },
    {
      label: "Tier",
      key: "Tier",
    },
   
   
  ],

  columns: [
    {
      label: "Is Consented?",
      key: "Is_Consented?",
    },
   
    {
      label: "JDE",
      key: "JDE",
    },
    {
      label: "Tier",
      key: "Tier",
    },
   
  ],
};
export const ConsentedAndNonConsentedMonthly = {
  filter: [
    {
      label: "Loyalty Id",
      key: "loyalty_id",
    },
   
    {
      label: "Customer Account Number",
      key: "customer_account_number",
    },
    {
      label: "Customer Billto Account Number",
      key: "customer_billto_account_number",
    },
    {
      label: "Loyalty Start Date",
      key: "loyalty_start_date",
    },
    {
      label: "Loyalty End Date",
      key: "loyalty_end_date",
    },
    {
      label: "Privilege Code",
      key: "privilege_code",
    },
    {
      label: "Tier",
      key: "tier",
    },
    {
      label: "System Managed",
      key: "system_managed",
    },
    {
      label: "Customer Sales Division Code",
      key: "customer_sales_division_code",
    },
    {
      label: "Market Class Code",
      key: "market_class_code",
    },
    {
      label: "Segment Code",
      key: "segment_code",
    },
    {
      label: "Consent By",
      key: "consent_by",
    },
    {
      label: "Is Consented?",
      key: "Is_Consented?",
    },
    {
      label: "Username Who Can Consent",
      key: "Username Who Can Consent",
    },
    {
      label: "Username Availability",
      key: "Username availability",
    } ,
    {
      label: "Segment Code NDSO/RDSO",
      key: "Segment_code NDSO/RDSO",
    } ,
    {
      label: "Points Available",
      key: "Points_available",
    } 
  ],

  columns: [
    {
      label: "Loyalty Id",
      key: "loyalty_id",
    },
   
    {
      label: "Customer Account Number",
      key: "customer_account_number",
    },
    {
      label: "Customer Billto Account Number",
      key: "customer_billto_account_number",
    },
    {
      label: "Loyalty Start Date",
      key: "loyalty_start_date",
    },
    {
      label: "Loyalty End Date",
      key: "loyalty_end_date",
    },
    {
      label: "Privilege Code",
      key: "privilege_code",
    },
    {
      label: "Tier",
      key: "tier",
    },
    {
      label: "System Managed",
      key: "system_managed",
    },
    {
      label: "Customer Sales Division Code",
      key: "customer_sales_division_code",
    },
    {
      label: "Market Class Code",
      key: "market_class_code",
    },
    {
      label: "Segment Code",
      key: "segment_code",
    },
    {
      label: "Consent Date",
      key: "consent_date",
    },
     {
      label: "Consent By",
      key: "consent_by",
    },
    {
      label: "Is Consented?",
      key: "Is_Consented?",
    },
    {
      label: "Username Who Can Consent",
      key: "Username Who Can Consent",
    },
    {
      label: "Username Availability",
      key: "Username availability",
    },
    {
      label: "Segment Code NDSO/RDSO",
      key: "Segment_code NDSO/RDSO",
    } ,
    {
      label: "Points Available",
      key: "Points_available",
    }
  ],
};
export const FSCSummary = {
  filter: [
    {
      label: "Enrollment",
      key: "Enrollment",
    },
   
    {
      label: "FSC Email",
      key: "FSC Email",
    },
    {
      label: "First Name",
      key: "First Name",
    },
    {
      label: "Last Name",
      key: "Last Name",
    },
    {
      label: "Redemption",
      key: "Redemption",
    },
     {
      label: "Transfer",
      key: "Transfer",
    },
  ],

  columns: [
    {
      label: "First Name",
      key: "First Name",
    },
    {
      label: "Last Name",
      key: "Last Name",
    },
    {
      label: "FSC Email",
      key: "FSC Email",
    },
    {
      label: "Enrollment",
      key: "Enrollment",
    },  
    {
      label: "Redemption",
      key: "Redemption",
    },
     {
      label: "Transfer",
      key: "Transfer",
    },
  ],
};
export const BenefitCodeWeekly = {
  filter: [    
    {
      label: "Customer Account Number",
      key: "customer_account_number",
    },
    {
      label: "Loyalty Id",
      key: "loyalty_id",
    },
    {
      label: "Customer Billto Account Number",
      key: "customer_billto_account_number",
    },
    {
      label: "Privilege Code",
      key: "privilege_code",
    },
    {
      label: "System Managed",
      key: "system_managed",
    },
   
  ],

  columns: [
    {
      label: "Customer Account Number",
      key: "customer_account_number",
    },
    {
      label: "Loyalty Id",
      key: "loyalty_id",
    },
    {
      label: "Customer Billto Account Number",
      key: "customer_billto_account_number",
    },
    {
      label: "Privilege Code",
      key: "privilege_code",
    },
    {
      label: "System Managed",
      key: "system_managed",
    },
   
  ],
};
export const FiscalMonth = {
  filter: [
    {
      label: "Loyalty Id",
      key: "loyalty_id",
    },
    {
      label: "Customer Billto Account Number",
      key: "customer_billto_account_number",
    },
    {
      label: "Tier",
      key: "tier",
    },
    {
      label: "Total Point Balance",
      key: "Total_point_balance",
    },
    {
      label: "Total Points Redeemed",
      key: "Total_Points_Redeemed",
    },
    {
      label: "Points Redeemed at Fiscal Month",
      key: "Points_redeemed_at_fiscal_month",
    },
    {
      label: "Segment Code",
      key: "Segment_code",
    },
   
  ],

  columns: [
    {
      label: "Loyalty Id",
      key: "loyalty_id",
    },
    {
      label: "Customer Billto Account Number",
      key: "customer_billto_account_number",
    },
    {
      label: "Tier",
      key: "tier",
    },
    {
      label: "Total Point Balance",
      key: "Total_point_balance",
    },
    {
      label: "Total Points Redeemed",
      key: "Total_Points_Redeemed",
    },
    {
      label: "Points Redeemed at Fiscal Month",
      key: "Points_redeemed_at_fiscal_month",
    },
    {
      label: "Segment Code",
      key: "Segment_code",
    },
  ],
};
export const FSCConsentWeekly = {
  filter: [
    {
      label: "Loyalty Id" ,
      key: "loyalty_id",
    },
    {
      label: "Customer Billto Account Number",
      key: "customer_billto_account_number",
    },
    {
      label: "Consent Flag",
      key: "consent_flag",
    },
    {
      label: "Consent By",
      key: "consent_by",
    },
    {
      label: "Consent Date",
      key: "consent_date",
    },
    {
      label: "Is Active",
      key: "is_active",
    },
    {
      label: "Status",
      key: "Status",
    },
    {
      label: "Uploaded By Email",
      key: "uploaded_by_email",
    },
    {
      label: "Modified By Email",
      key: "modified_by_email",
    },
   
  ],

  columns: [
    {
      label: "Loyalty Id" ,
      key: "loyalty_id",
    },
    {
      label: "Customer Billto Account Number",
      key: "customer_billto_account_number",
    },
    {
      label: "Consent Flag",
      key: "consent_flag",
    },
    {
      label: "Consent By",
      key: "consent_by",
    },
    {
      label: "Consent Date",
      key: "consent_date",
    },
    {
      label: "Is Active",
      key: "is_active",
    },
    {
      label: "Status",
      key: "Status",
    },
    {
      label: "Uploaded By Email",
      key: "uploaded_by_email",
    },
    {
      label: "Modified By Email",
      key: "modified_by_email",
    },
   
  ],
};

export const pointexpirationmonthly = {
  columns: [
    {
      label: "Loyalty Id" ,
      key: "loyalty_id",
    },
    {
      label: "Customer Billto Account Number",
      key: "customer_billto_account_number",
    },
    {
      label: "Points Expiring",
      key: "points_expiring",
    },
    {
      label: "Points Expiration Date",
      key: "points_expiration_date",
    },
    {
      label: "Date Of Transaction",
      key: "date_of_transaction",
    }
    
   
  ],
};
export const MarketoMailchimp = {
  filter: [    
    {
      label: "First Name",
      key: "first_name",
    },
    {
      label: "Last Name",
      key: "last_name",
    },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Loyalty Id",
      key: "loyalty_id",
    },
    {
      label: "Role",
      key: "role",
    }
  ],
  columns: [
    {
      label: "First Name",
      key: "first_name",
    },
    {
      label: "Last Name",
      key: "last_name",
    },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Customer Billto Account Number",
      key: "customer_billto_account_number",
    },    
    {
      label: "Loyalty Id",
      key: "loyalty_id",
    },
    {
      label: "Role",
      key: "role",
    },
    {
      label: "Points Left To Redeem",
      key: "points_left_to_redeem",
    },
    {
      label: "Total Points Available",
      key: "total_points_available",
    },
    // {
    //   label: "Points Earned",
    //   key: "points_earned",
    // },
    // {
    //   label: "Points Redeemed",
    //   key: "points_redeemed",
    // },
    {
      label: "Points Expiring At Month End",
      key: "points_expiring_at_month_end",
    },
    {
      label: "Upcoming Points Expiration Date",
      key: "upcoming_points_expiration_date",
    },
    {
      label: "Tier",
      key: "tier",
    },
    // {
    //   label: "Sales Amount",
    //   key: "sales_amount",
    // },
    // {
    //   label: "Anniversary Date",
    //   key: "anniversary_date",
    // },
    {
      label: "Is Active",
      key: "is_active",
    },
    {
      label: "Consent Flag",
      key: "consent_flag",
    },
    {
      label: "System Managed",
      key: "system_managed",
    },

    {
      label: "Create at",
      key: "created_at",
    },
    // {
    //   label: "Mktcls Modified",
    //   key: "mktcls_modified",
    // },
    // {
    //   label: "Segment Code",
    //   key: "segment_code",
    // }
  ]
};
export const RollForward = {
  filter: [],
  group: [],
  columns: [
    {
      label: "MNTH",
      key: "calculated_month",
    },
    {
      label: "Starting Points",
      key: "starting_balance_points",
    },
    {
      label: "ACH",
      key: "ach_points",
    },
    {
      label: "Premium",
      key: "premium_points",
    },
    {
      label: "Rebate",
      key: "rebate_points",
    },
    {
      label: "Legacy",
      key: "legacy_points",
    },
    {
      label: "Sale Points",
      key: "sales_points",
    },
    {
      label: "Courtesy",
      key: "points_adjustment",
    },
    {
      label: "Expired",
      key: "points_expiring",
    },
    {
      label: "Redeemed",
      key: "points_redeemed",
    },
    {
      label: "Ending Balance",
      key: "overall_balance",
    },
    {
      label: "MNTH ",
      key: "loyalty_calc_month",
    },
    {
      label: "Outstanding Balance by Month",
      key: "outstanding_balance",
    },
    {
      label: "Current Month Points Issued",
      key: "points_issued",
    },
    {
      label: "Redemption",
      key: "points_used",
    },
    {
      label: "Expired by Month",
      key: "fiscal_points_expired",
    },
    {
      label: "Redemption %",
      key: "redemption_percentage",
    },
  ],
};